import UtilsUrl from "../../utils/UtilsUrl";
import api from "./../api";

class ProductionOrderService {
  getAllPO(idUser) {
    return api.get(UtilsUrl.productionURL() + "/production-orders/" + idUser);
  }
  getAllWorkOrdersByPO(idUser,idPO) {
    return api.get(UtilsUrl.productionURL() + "/production-orders/getListWorkOrdersFromProductionOrder/" + idUser+"/"+idPO);
  }
  getAllWorkOrdersDetailsByIdByPO(idUser,idPO,idWorkOrder) {
    return api.get(UtilsUrl.productionURL() + "/production-orders/getWorkOrderByIdFromProductionOrder/" + idUser+"/"+idPO+"/"+idWorkOrder);
  }
  addProductionOrder(modal) {
    return api.post(
      UtilsUrl.productionURL() + "/production-orders/addProductionOrder",
      modal
    );
  }
  getProductFromProductionOrder(refOP,idUser,idWarehouse) {
    return api.get(
      UtilsUrl.productionURL() + "/productOrderWarehouseController/getProductFromProductionOrder/"+refOP+"/"+idUser+"/"+idWarehouse
    );
  }
  getEndProductFromProductionOrder(refOP,idUser,idWarehouse) {
    return api.get(
      UtilsUrl.productionURL() + "/productOrderWarehouseController/getEndProductFromProductionOrder/"+refOP+"/"+idUser+"/"+idWarehouse
    );
  }
  validateEndProduct(refOP,idUser,idWarehouse) {
    return api.get(
      UtilsUrl.productionURL() + "/productOrderWarehouseController/validateEndProduct/"+refOP+"/"+idUser+"/"+idWarehouse
    );
  }
  validateRawMateriel(refOP,idUser,idWarehouse) {
    return api.get(
      UtilsUrl.productionURL() + "/productOrderWarehouseController/validateRawMateriel/"+refOP+"/"+idUser+"/"+idWarehouse
    );
  }

  getPOById(idPO) {
    return api.get(UtilsUrl.productionURL() + "/production-orders/getProductionOrderById/" + idPO);
  }

  getWorkOrderById(idUser,idWorkOrder) {
    return api.get(UtilsUrl.productionURL() + "/production-orders/getWorkOrderById/" + idUser+"/"+idWorkOrder);
  }
  getCrewMembersByWorkStation(idUser,idWorkstation) {
    return api.get(UtilsUrl.productionURL() + "/production-orders/getCrewMembersByWorkStation/" + idUser+"/"+idWorkstation);
  }
  startWorkOrder(idUser,idWorkOrder) {
    return api.get(UtilsUrl.productionURL() + "/production-orders/startWorkOrder/" + idUser+"/"+idWorkOrder);
  }
  getListWorkOrders(idUser,startDate,endDate) {
    return api.get(UtilsUrl.productionURL() + "/production-orders/getListWorkOrders/" + idUser+"/"+startDate+"/"+endDate);
  }
  getListStepsByWorkOrder(idUser,idWorkOrder,startDate,endDate) {
    return api.get(UtilsUrl.productionURL() + "/production-orders/getListStepsByWorkOrder/" + idUser+"/"+idWorkOrder+"/"+startDate+"/"+endDate);
  }
  getListWorkOrdersByDay(idUser) {
    return api.get(UtilsUrl.productionURL() + "/production-orders/getListWorkOrders/" + idUser);
  }
  createWorkOrdersfromProductionOrder(idUser,idPO,scheduledDate) {
    return api.get(UtilsUrl.productionURL() + "/production-orders/createWorkOrdersfromProductionOrder/" +idUser+"/"+ idPO+"/"+ scheduledDate);
  }

  updateWorkOrdersComponents(model) {
    return api.post(UtilsUrl.productionURL() + "/production-orders/updateWorkOrdersComponents",model);
  }

  pointingWorkOrderBySupervisor(model) {
    return api.post(UtilsUrl.productionURL() + "/production-orders/pointingWorkOrderBySupervisor",model);
  }
  finishWorkOrder(model) {
    return api.post(UtilsUrl.productionURL() + "/production-orders/finishWorkOrder",model);
  }
}
export default new ProductionOrderService();
